module.exports = __webpack_public_path__ + "ssygl/img/404.2520ac1a.png";